// Spreadsheet exports.
//
// The half of an export that needs credentials is a back-end function, reached
// through the router, and the half that needs a browser lives here. Splitting
// there is what lets the data half be dispatched like anything else: it hands
// back plain rows, and nothing that cannot survive JSON crosses between them.

import { format } from 'date-fns';
import * as libCon from '../Constants.js';
import { getParticipantsForExports } from '../back-end/router.js';
import { exportToExcel } from './ExcelFunctions.js';

/**
 * Downloads the public participants table as a spreadsheet.
 *
 * Returns a bare status, the way it always has, so a caller only has to change
 * where it imports this from.
 *
 * @returns libCon.OK, or whichever error the fetch came back with
 */
export const exportParticipantsTable = async () => {
  const [status, records] = await getParticipantsForExports();

  if (status !== libCon.OK) return status;

  const now = new Date();

  exportToExcel(
    records,
    `Participants SEWA ${format(now, 'yyyy-MM-d')}.xlsx`,
    libCon.ATF_PARTICIPANT_EXPORT_COLUMNS
  );

  return libCon.OK;
};
